import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const KeysAndConstraints = () => (
  <QPhototModuleSubtopic
    title="KEYS (Candidate Keys, Primary Keys, Foreign Keys) & constraints"
    videos={[
      "https://www.youtube.com/embed/_UZLrD_R0T4",
      "https://www.youtube.com/embed/eK7gL-lGpjU"
    ]}
    takeaways={[
      { text: "Learn all the definitions and practice scenario-based questions." },
      { text: "For foreign keys, know conditions under which FKs can be null, can be duplicates, and how ON DELETE CASCADE behaves." },
      { text: "Understand constraint violations and how to fix them." }
    ]}
    questions={[
      { text: "Is it mandatory for a foreign key to be a primary key in another table?" },
      { text: "Can foreign keys be null values in the child relation?" },
      { text: "After enforcing the foreign key constraint using ON DELETE CASCADE rule, is it possible to delete a record in the child relation whose foreign key value is NOT NULL before deleting the corresponding primary key record in the parent relation?" },
      { text: "Can foreign keys have duplicate values?" },
      { text: "Can there exist more than one foreign key in a relation?" },
      { text: "Reason out why 'Parent Keys Not Found' error occurs during the enforcement of foreign keys and how to fix it with a suitable example." },
      { text: "Consider the following data values for the relations 'Product' and 'Purchase_order'. Do these relations satisfy all the constraints? If not, discuss the constraint violations in detail.",
        image:"/dbms_10.png"
       }
    ]}
    exampleVideos={[]}
  />
);

export default KeysAndConstraints;
